import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {TeammateModel} from '../../../../../models/api/teammateModel';
import {TeammatesFormatter} from '../../../../common/formatters/teammatesFormatter';

/*
 * Props.
 */

interface CommentEmojiReactionTooltipProps {
  teammates: ReadonlyArray<TeammateModel>;
  shortcode: string;
  userId?: number;
}

/*
 * Style.
 */

const StyledDiv = styled.div`
  max-width: 200px;
  text-align: center;
`;

/*
 * Component.
 */

export const CommentEmojiReactionTooltip: FC<CommentEmojiReactionTooltipProps> = (props) => {
  const {shortcode} = props;

  return (
    <StyledDiv>
      {renderTeammates(props)} <Trans id="comment-emojireacted">reacted with {shortcode}</Trans>
    </StyledDiv>
  );
};

function renderTeammates(props: CommentEmojiReactionTooltipProps) {
  if (props.teammates.length === 1 && props.teammates[0] && props.teammates[0].id === props.userId) {
    return <Trans id="comment-emojireacted-user">You</Trans>;
  }

  return <TeammatesFormatter teammates={props.teammates} limit={20} userId={props.userId} />;
}
